import { Conduit } from '@campingvision/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}ski/pass/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {

  /**
   * @param route
   * @returns {AxiosPromise}
   */
  getSeasonsWithRelations() {
    return conduit.get('seasons/with-relations');
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getSeasonById(seasonId) {
    return conduit.get(`seasons/${seasonId}`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getSeasonWithRelationsBySeasonId(seasonId) {
    return conduit.get(`seasons/${seasonId}/with-relations`);
  },

  /**
   * @param skiPassSeason
   * @returns {AxiosPromise}
   */
  createSeason(skiPassSeason) {
    return conduit.post('seasons/add', {
      skiPassSeason,
    });
  },

  /**
   * @param skiPassSeason
   * @returns {AxiosPromise}
   */
  saveSeason(skiPassSeason) {
    return conduit.put(`seasons/${skiPassSeason.id}/update`, {
      skiPassSeason,
    });
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getPersonCategoriesById(seasonId) {
    return conduit.get(`person-categories/season/${seasonId}`);
  },

  /**
   * @param skiPassPersonCategory
   * @returns {AxiosPromise}
   */
  createPersonCategory(skiPassPersonCategory) {
    return conduit.post('person-categories/add', {
      skiPassPersonCategory,
    });
  },

  /**
   * @param skiPassPersonCategory
   * @returns {AxiosPromise}
   */
  savePersonCategory(skiPassPersonCategory) {
    return conduit.put(`person-categories/${skiPassPersonCategory.id}/update`, {
      skiPassPersonCategory,
    });
  },

  /**
   * @param personCategoryId
   * @returns {AxiosPromise}
   */
  deletePersonCategory(personCategoryId) {
    return conduit.delete(`person-categories/${personCategoryId}/delete`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getDiscountsBySeasonId(seasonId) {
    return conduit.get(`discounts/season/${seasonId}/relations`);
  },

  /**
   * @param skiPassDiscount
   * @returns {AxiosPromise}
   */
  createDiscount(skiPassDiscount) {
    return conduit.post('discounts/add', {
      skiPassDiscount,
    });
  },

  /**
   * @param skiPassDiscount
   * @returns {AxiosPromise}
   */
  saveDiscount(skiPassDiscount) {
    return conduit.put(`discounts/${skiPassDiscount.id}/update`, {
      skiPassDiscount,
    });
  },

  /**
   * @param discountId
   * @returns {AxiosPromise}
   */
  deleteDiscount(discountId) {
    return conduit.delete(`discounts/${discountId}/delete`);
  },

  /**
   * @param discountId
   * @param personCategoryId
   * @returns {AxiosPromise}
   */
  savePersonCategoryOnDiscount(discountId, personCategoryId) {
    return conduit.post(
      `discounts/${discountId}/person-category/${personCategoryId}/add`,
      {},
    );
  },

  /**
   * @param discountId
   * @param personCategoryId
   * @returns {AxiosPromise}
   */
  deletePersonCategoryOnDiscount(discountId, personCategoryId) {
    return conduit.delete(`discounts/${discountId}/person-category/${personCategoryId}/delete`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getAreasBySeasonId(seasonId) {
    return conduit.get(`seasons/${seasonId}/areas`);
  },

  /**
   * @param seasonId
   * @param skiAreaId
   * @returns {AxiosPromise}
   */
  saveAreaOnSeason(seasonId, skiAreaId) {
    return conduit.post(
      `seasons/${seasonId}/areas/${skiAreaId}/add`,
      {},
    );
  },

  /**
   * @param seasonId
   * @param skiAreaId
   * @returns {AxiosPromise}
   */
  deleteAreaOnSeason(seasonId, skiAreaId) {
    return conduit.delete(`seasons/${seasonId}/areas/${skiAreaId}/delete`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getPeriodsWithPricesBySeasonId(seasonId) {
    return conduit.get(`periods/season/${seasonId}/with-prices`);
  },

  /**
   * @param skiPassPeriod
   * @returns {AxiosPromise}
   */
  createPeriod(skiPassPeriod) {
    return conduit.post('periods/add', {
      skiPassPeriod,
    });
  },

  /**
   * @param skiPassPeriod
   * @returns {AxiosPromise}
   */
  savePeriod(skiPassPeriod) {
    return conduit.put(`periods/${skiPassPeriod.id}/update`, {
      skiPassPeriod,
    });
  },

  /**
   * @param periodId
   * @returns {AxiosPromise}
   */
  deletePeriod(periodId) {
    return conduit.delete(`periods/${periodId}/delete`);
  },

  /**
   * @param anotherPeriodId
   * @param skiPassPeriod
   * @returns {AxiosPromise}
   */
  createPeriodToAnotherPeriod(anotherPeriodId, skiPassPeriod) {
    return conduit.post(`periods/add-to-another-period/${anotherPeriodId}`, {
      skiPassPeriod,
    });
  },

  /**
   * @param periodId
   * @returns {AxiosPromise}
   */
  getPeriodPricesByPeriodId(periodId) {
    return conduit.get(`periods/${periodId}/prices`);
  },

  /**
   * @param periodId
   * @param skiPassPeriodPrice
   * @returns {AxiosPromise}
   */
  createPeriodPrice(periodId, skiPassPeriodPrice) {
    return conduit.post(`periods/${periodId}/prices/add`, {
      skiPassPeriodPrice,
    });
  },

  /**
   * @param periodId
   * @param skiPassPeriodPrice
   * @returns {AxiosPromise}
   */
  savePeriodPrice(periodId, skiPassPeriodPrice) {
    return conduit.put(`periods/${periodId}/prices/${skiPassPeriodPrice.id}/update`, {
      skiPassPeriodPrice,
    });
  },

  /**
   * @param periodId
   * @param periodPriceId
   * @returns {AxiosPromise}
   */
  deletePeriodPrice(periodId, periodPriceId) {
    return conduit.delete(`periods/${periodId}/prices/${periodPriceId}/delete`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getSalesTypes() {
    return conduit.get('sales-types');
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/ski-pass-service.js